// /**
//  * Required tsconfig target to be >= es6
//  */
// export class BaseError extends Error {
//     constructor(message?: string) {
//         const trueProto = new.target.prototype;
//         super(message);
//         Object.setPrototypeOf(this, trueProto);
//     }
// }
export class BaseError extends Error {
    constructor(message) {
        super(message);
        this.message = message;
        Object.defineProperty(this, 'name', {
            get: () => this.constructor.name,
            set: () => { },
        });
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}
